import React, { PureComponent } from 'react'
import get from 'lodash/get'
import Link from 'next/link'
import getQuery from '@arsenal/arsenal/modules/getQuery'

import request from 'lib/request'
import { validatePhone, toNumber } from 'lib/utils'
import { getZT } from 'lib/zt-util'
import Toast from 'Components/toast'
import Button from 'Components/button'
import Select from 'Components/select'
import Statement from 'Components/footer-statement'
import CountDown from 'Components/countdown'
import CityPicker from 'Components/city-picker'
import { GlobalStoreContext } from 'Components/store'

import DealerList from './components/dealer-list'
import DeclareModal from './components/declare'

import { sendTeaCommEvent } from 'lib/tea-analyze'
import applyHttpsImage from 'lib/apply-https-img'

export interface IDealerHomeProps {
  seriesId: string | number
  // carId: number
  seriesName: string
  coverUrl: string
}

export interface IDealerHomeState {
  carId?: number
  cityName?: string
  carList: any[]
  phone: string
  vercode: string
  showVercode: boolean
  phoneError: boolean
  vercodeError: boolean
  dealerError: number
  isCounter: boolean
  showModal: boolean
}

export interface IDealerHomeCarOption {
  text: string
  value: number
  year: number
  [key: string]: number | string | boolean | Record<string, any>
}

export interface IDealerHomeCarOptionGroup {
  year: number
  label: string
  options: IDealerHomeCarOption[]
}

export default class DealerHome extends PureComponent<
  IDealerHomeProps,
  IDealerHomeState
> {
  static getInitialProps = async ({ query }: any) => {
    const { seriesId } = query

    const seriesInfo = await request.get(
      '/motor/car_page/v3/series_base_info/',
      {
        series_ids: seriesId,
      }
    )
    const info = get(seriesInfo, `data.${seriesId}`, {})
    return {
      seriesId,
      seriesName: info.series_name,
      coverUrl: info.cover_url,
    }
  }

  static contextType = GlobalStoreContext

  checkedDealerIds: string[] = []

  dealerRankList: number[] = []

  constructor(props: IDealerHomeProps) {
    super(props)

    this.state = {
      carList: [],
      // carId: props.carId,
      phone: '',
      vercode: '', // 验证码
      showVercode: false,
      phoneError: false, // 手机号错误
      vercodeError: false, // 验证码错误
      dealerError: 0, // 未选择经销商
      isCounter: false, // 验证码倒计时
      showModal: false, // 个人信息保护声明
    }
  }

  posting = false // 是否正在提交中

  componentDidUpdate() {
    const { state } = this.context
    const { cityName, carList } = this.state
    if (state.cityName && cityName !== state.cityName) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        cityName: state.cityName,
      })
      if (!carList || !carList.length) {
        this.getCarList(state.cityName)
      }
    }
  }

  componentDidMount() {
    const { state } = this.context
    const carId = getQuery('carId') as string
    if (carId) {
      this.setState({
        carId: Number(carId),
      })
    }
    this.getCarList(state.cityName)
  }

  async getCarList(cityName: string) {
    const { seriesId } = this.props
    const { carId } = this.state
    let activeCarId = carId || (getQuery('carId') as string)
    if (!activeCarId) {
      activeCarId = await this.getActiveCar(cityName)
    }
    // 车系列表
    return request
      .get('/motor/car_page/m/v2/series_all_json/', {
        series_id: seriesId,
        city_name: cityName,
        req_type: 'online',
      })
      .then((res: any) => {
        if (res.data && res.data.length) {
          const list: IDealerHomeCarOption[] = []
          res.data.forEach((item: any) => {
            if (item.type === '1037') {
              const { info } = item
              list.push({
                text: `${info.year}款 ${info.name}`,
                value: info.car_id,
                year: info.year,
              })
            }
          })
          list.sort((a, b) => b.year - a.year)
          let temp: IDealerHomeCarOptionGroup = {
            options: [],
            year: 0,
            label: '',
          }
          const carList: IDealerHomeCarOptionGroup[] = []
          list.forEach((item: IDealerHomeCarOption) => {
            if (temp.year !== item.year) {
              temp = {
                year: item.year,
                label: `${item.year}款`,
                options: [item],
              }
              carList.push(temp)
            } else {
              temp.options.push(item)
            }
          })

          const state: {
            carList: any[]
            carId?: number
          } = {
            carList,
          }

          state.carId = Number(activeCarId) || carList[0].options[0].value
          this.setState(state)
        }
      })
  }

  getActiveCar(cityName: string) {
    const { seriesId } = this.props
    return request
      .get('/motor/car_page/m/v3/dealer_car_info/', {
        series_id: seriesId,
        city_name: cityName,
      })
      .then((res: any) => {
        return get(res, 'data.id') || ''
      })
      .catch(() => {
        return ''
      })
  }

  onChangeCar = (option: IDealerHomeCarOption) => {
    const carId = option.value
    this.setState({
      carId,
    })
  }

  onChangeCity = (cityName: string) => {
    this.setState({
      cityName,
    })
  }

  onChangeDealer = (dealerIds: string[], indexList: number[]) => {
    this.checkedDealerIds = dealerIds
    this.dealerRankList = indexList
    this.setState({
      dealerError: 0,
    })
  }

  onChangeInput = (
    type: 'vercode' | 'phone',
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newState: any = {
      [type]: e.target.value,
      [`${type}Error`]: false,
    }
    this.setState(newState)
  }

  toggleModal = () => {
    const { showModal } = this.state
    this.setState({
      showModal: !showModal,
    })
  }

  onGetVercode = () => {
    const { phone } = this.state
    if (!validatePhone(phone)) {
      this.setState({
        phoneError: true,
      })
    } else if (!this.posting) {
      this.posting = true
      request
        .post('/motor/dealer/m/v2/send_vercode/', {
          phone,
        })
        .then((res: any) => {
          if (res.status === 0) {
            this.setState({
              isCounter: true,
            })
          } else {
            alert(res.prompts || '验证码发送失败，请稍后重试')
          }
        })
        .finally(() => {
          this.posting = false
        })
    }
  }

  onStopCounter = () => {
    this.setState({
      isCounter: false,
    })
  }

  onSubmit = () => {
    const { seriesName, seriesId } = this.props
    const { phone, showVercode, vercode, carId, cityName } = this.state
    const state = {
      phoneError: false,
      vercodeError: false,
      dealerError: 0,
    }
    let hasError = false

    if (!validatePhone(phone)) {
      hasError = true
      state.phoneError = true
    }

    if (showVercode && !/^\d+$/.test(vercode)) {
      hasError = true
      state.vercodeError = true
    }

    if (!this.checkedDealerIds.length) {
      hasError = true
      state.dealerError = 1
    }

    if (hasError) {
      this.setState(state)
    } else if (!this.posting) {
      this.posting = true
      request
        .post('/motor/dealer/m/v1/pc_commit_inquiry_info/', {
          phone,
          vercode,
          need_vercode: 1,
          car_id: carId,
          city_name: cityName,
          dealer_ids: this.checkedDealerIds.join(','),
          data_from: 'pc', // 2019-10-17 修改成pc 为了跟m站来源线索做区分
          extra: JSON.stringify({
            sys_location: cityName || '',
            zt: getZT(),
            from: 'pc',
          }),
        })
        .then(res => {
          const isSuccess = get(res, 'data.result', 'false') === 'true'
          sendTeaCommEvent('submit_inquiry_order', {
            car_series_name: seriesName,
            car_series_id: seriesId,
            car_style_id: carId,
            selected_city: cityName,
            dealer_id_list: this.checkedDealerIds.join(','),
            dealer_rank_list: this.dealerRankList.join(','),
            submit_status: isSuccess ? '成功' : '失败',
            default_select_dealer: 1,
            need_verify: 0,
            fail_reason: isSuccess ? '' : '询价失败，请重新尝试',
          })
          if (isSuccess) {
            Toast.success({
              title: '询价成功',
              description: '经销商将及时为您回电',
            })
            if (/^ad_ug_bdpc/.test(getZT())) {
              // 根据zt进行回传
              sendTeaCommEvent('pc_xunjia_click_submit', {
                LandingPageUrl: window.location.href,
                AppId: 3356,
                EventName: 'pc_xunjia_click_submit',
                EventTs: Math.floor(Date.now() / 1000),
                AdPlatformId: 'toutiao',
                growth_deepevent: '4',
              })
            }
          } else {
            const status = get(res, 'data.vercode_status', 0)
            if (status === 1) {
              this.setState({
                showVercode: true,
              })
            } else if (status === 2) {
              this.setState({
                vercodeError: true,
              })
            } else {
              alert('询价失败，请重新尝试')
            }
          }
        })
        .finally(() => {
          this.posting = false
        })
    }
  }

  render() {
    const { seriesName, coverUrl, seriesId } = this.props
    const {
      carId,
      carList,
      showVercode,
      phone,
      vercode,
      dealerError,
      phoneError,
      vercodeError,
      isCounter,
      showModal,
      cityName,
    } = this.state

    return (
      <>
        <div className="wrap">
          <h2 className="header">询底价</h2>
          <div className="content">
            <div className="clearfix">
              <Link
                href={`/auto/series?seriesId=${seriesId}`}
                as={`/auto/series/${seriesId}`}
              >
                <img
                  className="form-label form-label-image"
                  src={applyHttpsImage(coverUrl)}
                  alt={seriesName}
                />
              </Link>
              <div className="form-control">
                <h3 className="car-name">{seriesName}</h3>
                <Select
                  value={carId}
                  onChange={this.onChangeCar}
                  options={carList}
                />
              </div>
            </div>
            <div className="clearfix form-group">
              <label className="form-label">选择城市</label>
              <div className="form-control">
                <CityPicker onChange={this.onChangeCity} />
              </div>
            </div>
            <div className="clearfix form-group">
              <label className="form-label">手机号</label>
              <div className="form-control">
                <input
                  maxLength={11}
                  value={phone}
                  onChange={e => this.onChangeInput('phone', e)}
                  type="text"
                  placeholder="输入11位手机号"
                  className="phone"
                />
                {phoneError && (
                  <p className="form-error icon-warn">输入正确的手机号</p>
                )}
              </div>
            </div>
            {showVercode && (
              <div className="clearfix form-group">
                <label className="form-label">验证码</label>
                <div className="form-control">
                  <input
                    className="form-vcode"
                    value={vercode}
                    onChange={e => this.onChangeInput('vercode', e)}
                    type="text"
                    placeholder="输入验证码"
                  />
                  <Button
                    className="form-vcodebtn"
                    onClick={this.onGetVercode}
                    disabled={isCounter}
                  >
                    {isCounter ? (
                      <>
                        重发（
                        <CountDown count={36} onStop={this.onStopCounter} />
                        s）
                      </>
                    ) : (
                      '获取验证码'
                    )}
                  </Button>
                  {vercodeError && (
                    <p className="form-error icon-warn">输入正确的验证码</p>
                  )}
                </div>
              </div>
            )}
            <div className="form-right">
              <Button
                className="form-subbtn"
                type="primary"
                onClick={this.onSubmit}
              >
                询底价
              </Button>
              <p className="agree-tip">
                点击获取底价即视为同意
                <a onClick={this.toggleModal}>《个人信息保护声明》</a>
              </p>
            </div>
          </div>
          <DealerList
            carId={carId}
            cityName={cityName}
            error={dealerError}
            onChange={this.onChangeDealer}
          />
        </div>
        <DeclareModal show={showModal} onHide={this.toggleModal} />
        <style jsx>
          {`
            .wrap {
              width: 750px;
              margin: 0 auto;
              padding-top: 10px;
              padding-bottom: 60px;
              color: #1a1a1a;
              min-height: calc(100vh - 168px);
            }

            .icon-warn::before {
              content: '!';
              display: inline-block;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              font-size: 12px;
              line-height: 18px;
              font-weight: 500;
              border: 1px solid;
              text-align: center;
              margin-right: 4px;
            }

            .header {
              font-size: 24px;
              font-weight: 500;
              color: #1a1a1a;
              height: 60px;
              line-height: 60px;
              padding: 0 12px;
              border-bottom: 1px solid #ededed;
            }

            .content {
              padding: 20px 12px;
            }

            .car-name {
              font-size: 24px;
              font-weight: 500;
              margin-bottom: 12px;
            }

            .form-group {
              margin-bottom: 12px;
            }

            .form-label {
              float: left;
              width: 135px;
              text-align: right;
              line-height: 36px;
              font-size: 16px;
            }

            .form-label-image {
              height: 90px;
              cursor: pointer;
            }

            .form-control {
              float: left;
              width: 500px;
              margin-left: 20px;
            }

            .form-control :global(.select) {
              width: 100%;
              text-align: left;
            }

            input.form-control,
            .form-control input {
              width: 100%;
              height: 36px;
              padding: 8px 12px;
              border-radius: 4px;
              border: solid 1px #ededed;
              background-color: #fff;
              outline: none;
              font-size: 14px;
            }

            .form-control .form-vcode {
              width: 320px;
            }

            .form-vcodebtn,
            .form-subbtn {
              height: 36px;
              border-radius: 4px;
              text-align: center;
              outline: none;
              cursor: pointer;
            }

            .form-control :global(.form-vcodebtn) {
              margin-left: 8px;
              width: 172px;
              font-size: 14px;
              line-height: 36px;
              height: 36px;
            }

            .form-vcodebtn[disabled],
            .form-vcodebtn.disabled {
              pointer-events: none;
              cursor: not-allowed;
              color: #1a1a1a;
            }

            .form-right {
              width: 500px;
              margin-left: 155px;
            }

            .form-right :global(.form-subbtn) {
              display: block;
              height: 36px;
              line-height: 36px;
              font-size: 16px;
            }

            .agree-tip {
              color: #999;
              font-size: 12px;
              text-align: center;
              margin-top: 8px;
            }

            .agree-tip > a {
              text-decoration: underline;
            }

            .form-error {
              font-size: 14px;
              color: #fa5555;
              line-height: 36px;
            }

            .form-error.icon-warn::before {
              margin-right: 8px;
            }

            .phone:focus {
              border: solid 2px rgba(64, 101, 153, 0.1);
            }

            input:active,
            input:focus {
              border-color: #c1c1c1 !important;
            }
          `}
        </style>
        <Statement />
      </>
    )
  }
}
